import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Switch } from '../ui/switch';
import { Button } from '../ui/button';
import { Plus, X } from 'lucide-react';

export const AuthorCard = ({ formData, onChange }) => (
  <Card>
    <CardHeader><CardTitle>Autor</CardTitle></CardHeader>
    <CardContent className="space-y-4">
      <div>
        <Label htmlFor="author_name">Nome</Label>
        <Input id="author_name" value={formData.author_name} onChange={(e) => onChange('author_name', e.target.value)} className="mt-1" />
      </div>
      <div>
        <Label htmlFor="author_bio">Bio</Label>
        <Textarea id="author_bio" value={formData.author_bio} onChange={(e) => onChange('author_bio', e.target.value)} rows={3} className="mt-1" />
      </div>
    </CardContent>
  </Card>
);

export const TagsCard = ({ formData, onChange }) => {
  const [newTag, setNewTag] = useState('');
  const handleAdd = () => {
    if (newTag.trim() && !formData.tags.includes(newTag.trim())) {
      onChange('tags', [...formData.tags, newTag.trim()]);
      setNewTag('');
    }
  };
  return (
    <Card>
      <CardHeader><CardTitle>Tags</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        <div className="flex gap-2">
          <Input value={newTag} onChange={(e) => setNewTag(e.target.value)} placeholder="Nova tag" onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), handleAdd())} />
          <Button type="button" variant="outline" onClick={handleAdd}><Plus className="w-4 h-4" /></Button>
        </div>
        <div className="flex flex-wrap gap-2">
          {formData.tags.map((tag) => (
            <span key={tag} className="inline-flex items-center gap-1 px-3 py-1 bg-slate-100 rounded-full text-sm">
              {tag}
              <button type="button" onClick={() => onChange('tags', formData.tags.filter(t => t !== tag))} className="text-slate-400 hover:text-red-500">
                <X className="w-3 h-3" />
              </button>
            </span>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export const SettingsCard = ({ formData, onChange }) => (
  <Card>
    <CardHeader><CardTitle>Configurações</CardTitle></CardHeader>
    <CardContent className="space-y-4">
      <div className="flex items-center justify-between">
        <Label htmlFor="is_featured">Artigo em destaque</Label>
        <Switch id="is_featured" checked={formData.is_featured} onCheckedChange={(checked) => onChange('is_featured', checked)} />
      </div>
      <div>
        <Label htmlFor="reading_time">Tempo de leitura (min)</Label>
        <Input id="reading_time" type="number" value={formData.reading_time} onChange={(e) => onChange('reading_time', parseInt(e.target.value) || 5)} className="mt-1" />
      </div>
    </CardContent>
  </Card>
);

export const SEOCard = ({ formData, onChange }) => (
  <Card>
    <CardHeader><CardTitle>SEO</CardTitle></CardHeader>
    <CardContent className="space-y-4">
      <div>
        <Label htmlFor="seo_title">Título SEO</Label>
        <Input id="seo_title" value={formData.seo_title} onChange={(e) => onChange('seo_title', e.target.value)} placeholder={formData.title} className="mt-1" />
      </div>
      <div>
        <Label htmlFor="seo_description">Descrição SEO</Label>
        <Textarea id="seo_description" value={formData.seo_description} onChange={(e) => onChange('seo_description', e.target.value)} placeholder={formData.excerpt} rows={3} className="mt-1" />
      </div>
    </CardContent>
  </Card>
);
